<template>
  <v-form>
    <v-card flat class="mb-3">
      <div class="v-card-h1">{{ $schema.$title }}</div>

      <v-card-text class="error-top mt-8">
        <password-input name="password" :model="$schema.password" />

        <password-input name="new-password" :model="$schema.newPassword" />

        <password-input name="repeat-password" :model="$schema.confirmPassword" />
      </v-card-text>

      <v-card-actions>
        <v-col cols="6" offset="6" class="pr-0">
          <v-btn large color="primary" width="100%" elevation="0" :disabled="!isOnline" @click="changePassword">
            Zmień hasło
          </v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { formatError, SessionStorage } from '@witkac/kartamiejska-shared';
import { schemaMixin } from '@witkac/vuetify-components';

import PasswordInput from '@/components/forms/PasswordInput';
import schema from '@/schemas/changePassword.schema';
import { connectionMixin } from '@/mixins/connection';
import { notificationsMixin } from '@/mixins/notifications';

// @vuese
// Formularz zmiany hasła
// @group Forms
export default {
  components: { PasswordInput },
  mixins: [connectionMixin, notificationsMixin, schemaMixin],
  schema,
  data() {
    return { model: {} };
  },
  methods: {
    // @vuese
    // Zmiana hasła
    changePassword() {
      if (this.$schema.$validateAll().length) {
        this.notifyError('Należy poprawić błędy formularza.');
        return;
      }
      this.$store
        .dispatch('auth/changePassword', {
          ...this.$schema.$getData(),
          userId: localStorage.getItem(SessionStorage.USER_ID)
        })
        .then(() => {
          this.notifySuccess('Zmieniono hasło użytkownika.');
          this.$schema.$setData({ password: '', newPassword: '', confirmPassword: '' });
          this.$schema.$reset();
          this.$emit('password-changed');
        })
        .catch(error => this.notifyError(formatError(error)));
    }
  }
};
</script>
